// shiftSummary.js — Shift Summary modal for Personnel Metrics.
// Shows current-shift workload, completion breakdown, nonconformances
// raised, station movement, and active vs idle time split.
// Receives the selected personnel object as a prop.
import React from "react";
import "../styles/shiftSummary.css";

const ShiftSummary = ({ person }) => {
  const s = person.shiftSummary;
  const completionPct = s.jobsAssigned
    ? Math.round((s.jobsCompleted / s.jobsAssigned) * 100)
    : 0;

  const completionColor =
    completionPct >= 80
      ? "#38a169"
      : completionPct >= 50
        ? "#d69e2e"
        : "#cc0000";

  return (
    <>
      <p className="modal-description">
        Shift overview for {person.fullName} &mdash; {person.employeeId} &bull;{" "}
        {person.department}
      </p>

      {/* Shift time band */}
      <div className="modal-section">
        <h3>Shift Window</h3>
        <div className="pm-shift-band">
          <div className="pm-shift-time">
            <span className="pm-shift-time-label">Start</span>
            <span className="pm-shift-time-value">{s.shiftStart}</span>
          </div>
          <div className="pm-shift-divider" />
          <div className="pm-shift-time">
            <span className="pm-shift-time-label">End</span>
            <span className="pm-shift-time-value">{s.shiftEnd}</span>
          </div>
          <div className="pm-shift-divider" />
          <div className="pm-shift-time">
            <span className="pm-shift-time-label">Active</span>
            <span className="pm-shift-time-value pm-shift-time-value--green">
              {s.totalActiveTime}
            </span>
          </div>
          <div className="pm-shift-divider" />
          <div className="pm-shift-time">
            <span className="pm-shift-time-label">Idle</span>
            <span className="pm-shift-time-value pm-shift-time-value--muted">
              {s.totalIdleTime}
            </span>
          </div>
        </div>
      </div>

      {/* Job completion stats */}
      <div className="modal-section">
        <h3>Job Completion</h3>
        <div className="pm-shift-band">
          <div className="pm-shift-time">
            <span className="pm-shift-time-label">Completed</span>
            <span className="pm-shift-time-value pm-shift-time-value--green">
              {s.jobsCompleted}
            </span>
          </div>
          <div className="pm-shift-divider" />
          <div className="pm-shift-time">
            <span className="pm-shift-time-label">In Progress</span>
            <span className="pm-shift-time-value pm-shift-time-value--orange">
              {s.jobsInProgress}
            </span>
          </div>
          <div className="pm-shift-divider" />
          <div className="pm-shift-time">
            <span className="pm-shift-time-label">Nonconformances</span>
            <span
              className={`pm-shift-time-value ${s.nonconformancesRaised > 0 ? "pm-shift-time-value--red" : "pm-shift-time-value--green"}`}
            >
              {s.nonconformancesRaised}
            </span>
          </div>
        </div>
      </div>

      {/* Station movement */}
      <div className="modal-section">
        <h3>Stations Visited</h3>
        <div className="pm-stations-list">
          {s.stationsVisited.map((st, i) => (
            <span key={i} className="pm-station-tag">
              {st}
            </span>
          ))}
        </div>
      </div>
    </>
  );
};

export default ShiftSummary;
